export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";